'use strict';Object.defineProperty(exports,"__esModule",{value:true});var _Flex=require('./Flex.web');var _Flex2=_interopRequireDefault(_Flex);
var _FlexItem=require('./FlexItem.web');var _FlexItem2=_interopRequireDefault(_FlexItem);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{"default":obj};}
_Flex2["default"].Item=_FlexItem2["default"];exports["default"]=_Flex2["default"];module.exports=exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/antd-mobile/lib/flex/index.web.js
// module id = 266
// module chunks = 0